import React, {FC} from 'react';
import {Box, BoxProps} from '@material-ui/core';

export const FlexColumn: FC<BoxProps> = React.memo((props) => {
  return (
    <Box display="flex" flexDirection="column" {...props}>
      {props.children}
    </Box>
  );
});
